/// <reference types="./adminGetEntityList.d.ts" />
import { notOk, ok, } from '@dossierhq/core';
import { authVerifyAuthorizationKey } from '../Auth.js';
import { decodeAdminEntity } from '../EntityCodec.js';
export async function adminGetEntityList(schema, authorizationAdapter, databaseAdapter, context, references) {
    if (references.length === 0) {
        return ok([]);
    }
    const entityInfoResult = await databaseAdapter.adminEntityGetMultiple(context, references);
    if (entityInfoResult.isError())
        return entityInfoResult;
    const result = [];
    for (const reference of references) {
        const entityMain = entityInfoResult.value.find((it) => it.id === reference.id);
        result.push(await mapItem(schema, authorizationAdapter, context, reference, entityMain));
    }
    return ok(result);
}
async function mapItem(schema, authorizationAdapter, context, reference, values) {
    if (!values) {
        return notOk.NotFound('No such entity');
    }
    const authResult = await authVerifyAuthorizationKey(authorizationAdapter, context, {
        authKey: values.authKey,
        resolvedAuthKey: values.resolvedAuthKey,
    });
    if (authResult.isError())
        return authResult;
    return decodeAdminEntity(schema, values);
}
//# sourceMappingURL=adminGetEntityList.js.map